export const VIDEO_EXTS = ["mp4", "webm", "mov", "mkv", "m4v", "3gp"];
export const EFFECT_ACCEPT =
  ".svga,.gift,.mp4,.webm,.mov,.mkv,.m4v,.3gp,video/mp4,video/webm,video/quicktime,video/*";
export const FRAME_ACCEPT = ".svga";
export const LARGE_PREVIEW_BYTES = 25 * 1024 * 1024;

export function fileExt(name = "") {
  const base = String(name).split(/[/\\?#]/).pop();
  const dot = base.lastIndexOf(".");
  return dot >= 0 ? base.slice(dot + 1).toLowerCase() : "";
}

export function isVideoFile(file) {
  if (!file) return false;
  return VIDEO_EXTS.includes(fileExt(file.name)) || String(file.type || "").startsWith("video/");
}

export function isSvgaFile(file) {
  const ext = fileExt(file?.name || "");
  return ext === "svga" || ext === "gift";
}

export function isVideoPath(path = "") {
  return VIDEO_EXTS.includes(fileExt(path));
}

export function captureVideoPoster(file) {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const video = document.createElement("video");
    video.preload = "auto";
    video.muted = true;
    video.playsInline = true;
    let done = false;
    const finish = (blob) => {
      if (done) return;
      done = true;
      URL.revokeObjectURL(url);
      resolve(blob);
    };
    video.onerror = () => finish(null);
    video.onloadeddata = () => {
      const draw = () => {
        try {
          const canvas = document.createElement("canvas");
          const width = video.videoWidth || 480;
          const height = video.videoHeight || 480;
          canvas.width = width;
          canvas.height = height;
          canvas.getContext("2d").drawImage(video, 0, 0, width, height);
          canvas.toBlob((blob) => finish(blob), "image/png");
        } catch (error) {
          finish(null);
        }
      };
      const duration = Number.isFinite(video.duration) ? video.duration : 0;
      const target = duration > 0 ? Math.min(0.2, duration / 2) : 0;
      if (target > 0) {
        video.onseeked = draw;
        try {
          video.currentTime = target;
        } catch (error) {
          draw();
        }
      } else {
        draw();
      }
    };
    video.src = url;
  });
}
